"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _lodash = _interopRequireDefault(require("lodash"));

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _Base = _interopRequireDefault(require("../base/Base"));

var _MultilevelCatalog = _interopRequireDefault(require("./MultilevelCatalog.form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactDOM;
var React;
var multilevelCatalog;

try {
  ReactDOM = require('react-dom');
  React = require('react');
  multilevelCatalog = require('@platform/multilevel-catalog');
} catch (error) {
  console.error(error);
}

var _default = function _default(setting) {
  var client = setting.client,
      intlStore = setting.intlStore,
      theme = setting.theme;

  var MultilevelCatalog =
  /*#__PURE__*/
  function (_WithLogic) {
    _inherits(MultilevelCatalog, _WithLogic);

    function MultilevelCatalog() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, MultilevelCatalog);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultilevelCatalog)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "isChanged", false);

      return _this;
    }

    _createClass(MultilevelCatalog, [{
      key: "getValue",
      value: function getValue() {
        return this.dataValue;
      }
    }, {
      key: "viewOnlyBuild",
      value: function viewOnlyBuild() {
        this.createElement();
        this.createViewOnlyLabel(this.element);
        this.createInput(this.element);
      }
    }, {
      key: "restoreValue",
      value: function restoreValue() {
        return;
      }
    }, {
      key: "createInput",
      value: function createInput(container) {
        var input = this.ce('div', {
          class: 'multilevel-catalog'
        });
        input.style.border = "1px solid ".concat(this.blockedUserColor || 'transparent');

        if (ReactDOM && React && multilevelCatalog) {
          this.createMultilevelCatalog(input);
        } else {
          input.textContent = "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A: ".concat(this.component.catalogCode || '-');
        }

        this.addInput(input, container);
        this.errorContainer = container;
        return input;
      }
    }, {
      key: "isEmpty",
      value: function isEmpty(value) {
        return Boolean(!Object.keys(value).length);
      }
    }, {
      key: "setValue",
      value: function setValue(value, flags) {
        if (!_lodash.default.isEqual(this.dataValue, value)) {
          this.isChanged = true;
        }

        if (!flags) {
          this.dataValue = value;
        }

        if (this.isChanged) {
          this.onChange();
          this.checkValidity(this.data, true);
          this.pristine = false;
        }
      }
    }, {
      key: "createMultilevelCatalog",
      value: function createMultilevelCatalog(container) {
        var _this2 = this;

        setTimeout(function () {
          if (!_this2.currentValue) {
            _this2.currentValue = _objectSpread({}, _this2.dataValue);
          }

          ReactDOM.render(React.createElement(multilevelCatalog.MultilevelCatalog, {
            client: client,
            intlStore: intlStore,
            theme: theme,
            isViewOnly: _this2.viewOnly,
            isDisabled: _this2.shouldDisable,
            catalogCode: _this2.component.catalogCode,
            isWithAutoCheck: _this2.component.isWithAutoCheck,
            isWithCode: _this2.component.isWithCode,
            sort: _this2.component.sort,
            setValue: _this2.setValue.bind(_this2),
            checkedItems: _this2.dataValue,
            triggerUpdate: _this2.triggerUnblockByUser,
            triggerBlock: _this2.triggerBlockByUser
          }), container);
        }, 0);
      }
    }, {
      key: "emptyValue",
      get: function get() {
        return {};
      }
    }], [{
      key: "schema",
      value: function schema() {
        for (var _len2 = arguments.length, extend = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          extend[_key2] = arguments[_key2];
        }

        return _Base.default.schema.apply(_Base.default, [{
          label: 'Multilevel Catalog',
          key: 'multilevelCatalog',
          type: 'multilevelCatalog'
        }].concat(extend));
      }
    }, {
      key: "editForm",
      get: function get() {
        return _MultilevelCatalog.default;
      }
    }, {
      key: "builderInfo",
      get: function get() {
        return {
          title: 'Multilevel Catalog',
          icon: 'fa fa-list-ul',
          group: 'advanced',
          weight: 120,
          schema: MultilevelCatalog.schema()
        };
      }
    }]);

    return MultilevelCatalog;
  }((0, _WithLogic2.default)(_Base.default));

  return MultilevelCatalog;
};

exports.default = _default;